module.exports = __webpack_public_path__ + "static/media/sample-golfer.e799d5f9.png";